import { apiFetch } from '@/api'
import { NewSamplePost } from '@/interfaces/api/Sample'

export const fetchPostSample = async (payload: NewSamplePost): Promise<[]> =>
  (await apiFetch('/samples', { method: 'POST', body: payload })).data
